import { CONTROL_TYPE } from "@lhd/components/Formik";
import { ColDefCustom } from "types/tableWithForm.type";
import * as Yup from "yup";
import { TYPE_INPUT } from "@lhd/components/TableForm/types";

// Column definitions for registration code table
export const registrationCodeTableColumnDefs: ColDefCustom[] = [
  {
    field: "registration_number",
    headerName: "インボイス登録番号",
    minWidth: 150,
    type: CONTROL_TYPE.REGISTER_CODE,
    editInfo: {
      type: TYPE_INPUT.REGISTER_CODE,
    },
  },
  {
    field: "start_date",
    headerName: "開始日",
    minWidth: 150,
    type: CONTROL_TYPE.DATE,
    lessThanField: "end_date",
    endGreaterStart: true,
    timeRangeLock: true,
  },
  {
    field: "end_date",
    headerName: "終了日",
    minWidth: 150,
    type: CONTROL_TYPE.DATE,
    endGreaterStart: true,
    greaterThanField: "start_date",
    disabledReCordPast: false,
    grayRecordPast: true,
  },
  {
    field: "created_at",
    headerName: "システム日",
    minWidth: 150,
    type: CONTROL_TYPE.DATE,
    disabled: true,
  },
  {
    field: "updated_by",
    headerName: "更新者",
    minWidth: 150,
    type: CONTROL_TYPE.INPUT,
    disabled: true,
  },
];

// Validation schema for registration code table
export const validationSchemaRegistrationCode = Yup.object().shape({
  // registration_number: Yup.string().max(
  //   50,
  //   "登録番号は50文字以内で入力してください",
  // ),
});
